// NOTE: If you use this component, you will have to specify its z-index in the CSS. We are
//  registering z-indexes there, and it makes sense to keep them in one place!

import React from 'react'
import PropTypes from 'prop-types'

import Transition from './Pieces/Transition'

const Overlay = ({className, isVisible, onClick}) => (
  <Transition enter={{opacity: 0.8}} leave={{opacity: 0}}>
    {isVisible && (
      <button
        key="0"
        className={className}
        onClick={onClick}
        style={{
          backgroundColor: 'black',
          border: '0',
          bottom: '0',
          display: 'block',
          left: '0',
          opacity: '0',
          padding: '0',
          position: 'fixed',
          right: '0',
          top: '0',
          width: '100%',
        }}
      />
    )}
  </Transition>
)

Overlay.defaultProps = {
  className: undefined,
}

Overlay.propTypes = {
  className: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default Overlay
